import { EditPeopleModal } from "@/components/EditPeopleModal/EditPeopleModal"
import {
  AddOrEditPeopleFormStepContext,
  useAddOrEditPeopleStepFormContext,
} from "@/components/EditPeopleModal/context/AddOrEditPeopleFormStepContext"
import { UserPlusIcon } from "@/components/Icons"
import { type EntityLocked, SHARED_DATA_TYPE } from "@/domain/sharedData/constants"
import type { PeopleJsonldReadItemPeople } from "@/networking/api"
import { isNotBlank } from "@/utils/ts-utils"
import { Button, useDisclosure } from "@chakra-ui/react"
import { FormattedMessage, useIntl } from "react-intl"
import { useCreationMultiStepFormContext } from "../context/ShareRequestInterbuCreateModalContext"

const PeopleActionButton: React.FC<React.PropsWithChildren<{ canProp: string }>> = ({
  children,
  canProp,
}) => {
  const { can } = useAddOrEditPeopleStepFormContext()
  return (can[canProp as keyof typeof can] ?? false) ? <>{children}</> : null
}

export default () => {
  const intl = useIntl()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { setSharedEntity } = useCreationMultiStepFormContext()

  const onCloseWithSuccess = (people?: PeopleJsonldReadItemPeople) => {
    if (isNotBlank(people?.id))
      setSharedEntity({ ...(people as EntityLocked), type: SHARED_DATA_TYPE.INTER_BU })
    onClose()
  }

  return (
    <AddOrEditPeopleFormStepContext>
      <PeopleActionButton canProp="create">
        <Button
          aria-label={intl.formatMessage({
            id: "client.addPeople",
          })}
          variant="outline"
          size="sm"
          py={1}
          // Its own width, under the client field: the column would stretch it otherwise.
          alignSelf="flex-start"
          onClick={onOpen}
        >
          <UserPlusIcon h={7} mr={2} />
          <FormattedMessage id="client.addPeople" />
        </Button>
      </PeopleActionButton>
      <EditPeopleModal isOpen={isOpen} onClose={onCloseWithSuccess} />
    </AddOrEditPeopleFormStepContext>
  )
}
